/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SubSideNavChildrenIndexEnum {
    INSURED_MAIN = 0,
    INSURED_INFORMATION = 1,
    INSURED_USERS = 2,
    DIARY_DIARY = 0,
    DIARY_TODO = 1,
    BILLING_ACTIVITY = 0,
    BILLING_PAYROLL_REPORTS = 1,
    BILLING_ACCOUNTS = 2,
    BILLING_SCHEDULED = 3,
    POLICY_HISTORY = 0,
    POLICY_CANCELLATION = 1,
    POLICY_CERTIFICATES = 2,
    POLICY_WAIVERS = 3,
    POLICY_DIVIDENDS = 4,
    CLAIMS_INCIDENTS = 0,
    CLAIMS_CLAIMS = 1,
    PAYMENT_RECURRING = 0,
    PAYMENT_APPROVALS = 1,
    PAYMENT_BATCH = 2,
    PAYMENT_HISTORY = 3,
    PROGRAMS_INFORMATION = 0,
    PROGRAMS_RATE_TABLES = 1,
    PROGRAMS_RATING = 2,
    PROGRAMS_EXCESS_REINSURANCE = 3,
}
